export enum Variant {
    PRIMARY = "primary",
    SECONDARY = "secondary",
    ERROR = "error",
}